import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "channel-facebook",
  "use": "channel-facebook-usage",
  "viewBox": "0 0 14 25",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 25\" id=\"channel-facebook\"><path clip-rule=\"evenodd\" d=\"M13.13 8.75H8.87V6.84a1 1 0 011-1.1h3v-4H8.54c-3.93 0-4.67 3-4.67 4.86v2.15h-3v4h3v11.5h5v-11.5h3.85l.41-4z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/channel-facebook.svg
// module id = vqaW
// module chunks = 39 44